import type { ReactNode } from 'react';
import { Banner } from '../Banner/Banner.tsx';
import { Button } from '../Button/Button.tsx';
import styles from './ScreenError.module.css';

export type ScreenErrorProps = {
  /** Who to tell if it keeps happening. */
  help: ReactNode;
  title?: ReactNode;
};

/** When a screen breaks: say it plainly and offer to reload. Apps show it as the router's error element. */
export function ScreenError({ help, title = 'Algo salió mal en esta pantalla' }: ScreenErrorProps) {
  return (
    <div className={styles.page}>
      <Banner
        tone="error"
        title={title}
        action={
          <Button size="sm" onClick={() => window.location.reload()}>
            Recargar
          </Button>
        }
      >
        Recarga la página. {help}
      </Banner>
    </div>
  );
}
